import { useMemo } from 'react'
import { useInspectorContext, useInspectorSelectedElement } from './inspector'
import { findClosestFrameElementForSelection } from '@sketch/inspector'
import {
  useGridAndLayoutSettingsForFrame,
  useToggleGridSettingsForFrame,
} from '../../components/GridsAndLayoutsProvider/gridsAndLayouts.hooks'

/**
 * The Zoom component takes an optional prop `gridAndLayout` which contains
 * props to show and control the toggles for grid and layout in the zoom dropdown.
 * The result of this hook can be fed directly to the Zoom component.
 */
export function useGridAndLayoutPropForZoomComponent() {
  const { isInspectorActive, sketchSceneRootElement } = useInspectorContext()
  const selectedElement = useInspectorSelectedElement()

  // Show grid/layout options only if an artboard is selected or if we are in
  // the frame view
  const frameElement = findClosestFrameElementForSelection(
    selectedElement,
    sketchSceneRootElement
  )

  const { isGridEnabled, isLayoutEnabled } = useGridAndLayoutSettingsForFrame(
    frameElement?.elementUUID
  )

  const { toggleGrid, toggleLayout } = useToggleGridSettingsForFrame(
    frameElement?.elementUUID
  )

  const gridAndLayout = useMemo(() => {
    if (!isInspectorActive || !frameElement) {
      return undefined
    }

    return {
      isGridEnabled,
      isLayoutEnabled,
      toggleGrid,
      toggleLayout,
    }
  }, [
    frameElement,
    isGridEnabled,
    isInspectorActive,
    isLayoutEnabled,
    toggleGrid,
    toggleLayout,
  ])

  return gridAndLayout
}
